import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_4 } from 'constants/theme-constants';
import styled from 'styled-components';

export const DateRangeSelectorWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    position: relative;
    align-items: center;
    gap: ${cxTheme.spacing[SPACING_4]};
  
    
    .shell-date-picker-dropdown.shell-date-picker-dropdown-placement-bottomLeft  {
      z-index: ${cxTheme.zIndex[5]};
    }

    @media screen and (max-width: ${cxTheme.breakpoints.desktop}px) {
      width: 100%;
    }
  `}
`;
